/**
 * Trigger a client-side download of `data` as pretty-printed JSON.
 *
 * Blob + object URL, NEVER a data: URI — data: URIs embed the whole payload
 * in the href and hit browser URL-length limits on large exports (the old
 * memories export failed silently this way once payloads grew).
 *
 * @param {*} data - JSON-serializable value to download
 * @param {string} filename - Suggested filename for the browser
 */
export function downloadJson(data, filename) {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
